import React, { useEffect } from "react";
import cl from "./ShippingPolicy.module.css";
import { animateScroll as scroll } from "react-scroll";

const ShippingPolicy = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <section className={cl.app_policy}>
      <h1>Política de Envío</h1>
      <p>Última actualización: 07 de febrero de 2024</p>
      <p>
        Nuestro objetivo es ofrecerte las mejores opciones de envío, estés donde
        estés. Entregamos a cientos de clientes en todo el mundo cada día y nos
        esforzamos por brindarte servicios de la más alta calidad.
      </p>
      <p>
        Sabemos que una vez que has comprado algo, estás ansioso por recibir tu
        pedido lo antes posible. Consulta a continuación para obtener más
        detalles sobre la política de envío.
      </p>
      <p>Pregunta: ¿Pueden garantizar los tiempos de envío?</p>
      <p>
        Respuesta: Desafortunadamente no, ya que estos dependen del servicio
        postal. Enviamos los pedidos tan pronto como podemos después de recibir
        tu pago. No procesamos pedidos durante los fines de semana o días
        festivos.
      </p>
      <p>Pregunta: ¿Puedo rastrear mi pedido?</p>
      <p>
        Respuesta: ¡Sí! Nuestro servicio es completamente rastreable en los
        sitios web.
      </p>
      <p>Pregunta: ¿A dónde envían?</p>
      <p>Respuesta: Enviamos a todo el mundo.</p>
      <p>
        Pregunta: ¿Puedo solicitar un reembolso si mi pedido no llega a tiempo
        para una fecha específica?
      </p>
      <p>
        Respuesta: No, lamentablemente no podemos reembolsar los pedidos que ya
        han sido enviados. Sin embargo, puedes devolver el pedido si deseas un
        reembolso.
      </p>
      <p>
        Debido a la influencia del COVID-19 y las restricciones políticas en
        varios países, habrá un gran retraso en todos los envíos exprés, y la
        logística no puede garantizar completamente el límite de tiempo.
      </p>
      <p>Tiempo de entrega: 2-7 días, tiempo de envío: 7-15 días</p>
    </section>
  );
};

export default ShippingPolicy;
